import React from 'react'

const NoAgenda = ({ eventMarketingUrl, userTitle, userOrganizationName, userFullName}) => {
  return(
    <div className='container no-agenda'>
      <h1>Welcome { userFullName }</h1>
      <h5>{ userTitle }{userTitle !== null && userOrganizationName !== null ? ', ' : ''}{ userOrganizationName }</h5>
      <br/>
      <h4>Agenda Coming Soon</h4>
      <p>We are currently working with C-level leaders in your community to build the most timely and relevant agenda. All of our sessions, topics and discussions are driven by your distinguished Regional Governing Body peers, to ensure the most valuable experience.</p>
      <p>In the meantime <a href={ eventMarketingUrl }>click here</a> for the latest updates to this program.</p>
    </div>
  )
}

export default NoAgenda